import { render, staticRenderFns } from "./WHOQOL_BREF.vue?vue&type=template&id=117d2b9a&"
import script from "./WHOQOL_BREF.vue?vue&type=script&lang=js&"
export * from "./WHOQOL_BREF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports